export const PAID_PROJECT_UI_STATUSES = [
  'Declined',
  'Inquiry',
  'Proposal',
  'In Progress',
  'In Review',
  'Completed',
  'Canceled',
  'Invite Pending',
  'Rejected',
  'Revision Requested',
  'On Hold',
  'Change requested',
] as const;

export const VALID_STATUSES_FOR_CHANGE_REQUEST = [
  'IN_PROGRESS',
  'SUBMISSION_CREATED',
  'SUBMISSION_DECLINED',
];
